import React from 'react';
export const GlobalLoader = () => {
    return (React.createElement("div", { className: 'd-flex align-items-center justify-content-center vh-100 vw-100' },
        React.createElement("div", { className: 'spinner-border text-primary mt-5', role: 'status', style: { width: '40px', height: '40px' } },
            React.createElement("span", { className: 'visually-hidden' }, "Loading..."))));
};
